<template>
  <v-app-bar
    app
    :color="isScrolled ? 'white' : 'transparent'"
    :elevation="isScrolled ? 4 : 0"
    :class="{ 'py-2': !isScrolled, 'py-1': isScrolled }"
    fixed
  >
    <div
      class="container-custom d-flex justify-space-between align-center w-100"
    >
      <router-link to="/" class="text-decoration-none">
        <div v-if="!mini" class="d-flex align-center">
          <img
            width="45px"
            height="auto"
            class="mt-0 ml-5"
            src="/assets/public/ucc-logo-icon.png"
          />
          <div class="d-flex align-center ml-4 mt-1" style="position: relative">
            <span style="color: #146cbe; font-weight: bold; font-size: 20px">
              Urban Care Community
            </span>
            <v-icon
              color="red"
              size="18"
              style="position: absolute; top: -3px; right: -16px"
            >
              mdi-heart
            </v-icon>
          </div>
        </div>
      </router-link>

      <!-- Desktop Navigation -->
      <div class="d-none d-lg-flex align-center">
        <template v-for="link in navLinks">
          <v-btn
            v-if="!link.href.startsWith('#')"
            :key="link.name"
            :to="link.href"
            text
            class="nav-link mx-2"
          >
            {{ link.name }}
          </v-btn>

          <v-btn
            v-else
            :key="link.name"
            text
            class="nav-link mx-2"
            @click="navigateTo(link.href)"
          >
            {{ link.name }}
          </v-btn>
        </template>

        <v-btn
          color="primary"
          class="white--text ml-4 btn-custom"
          depressed
          rounded
          to="/ucc-login"
        >
          Login
        </v-btn>
      </div>

      <!-- Mobile Navigation Toggle -->
      <v-app-bar-nav-icon
        class="d-flex d-lg-none"
        @click="isMenuOpen = !isMenuOpen"
        color="grey darken-2"
      ></v-app-bar-nav-icon>
    </div>

    <!-- Mobile Navigation Menu -->
    <v-navigation-drawer
      v-model="isMenuOpen"
      absolute
      temporary
      right
      width="300"
      height="250"
    >
      <template v-for="link in navLinks">
        <!-- For normal routes -->
        <v-list-item
          v-if="!link.href.startsWith('#')"
          :key="link.name"
          :to="link.href"
          @click="isMenuOpen = false"
          class="nav-link"
        >
          <v-list-item-title class="text-subtitle-1 font-weight-medium">
            {{ link.name }}
          </v-list-item-title>
        </v-list-item>

        <!-- For scrolling sections -->
        <v-list-item
          v-else
          :key="link.name"
          class="nav-link"
          @click="
            () => {
              isMenuOpen = false;
              navigateTo(link.href);
            }
          "
        >
          <v-list-item-title class="text-subtitle-1 font-weight-medium">
            {{ link.name }}
          </v-list-item-title>
        </v-list-item>
      </template>

      <v-btn
        color="primary"
        class="white--text mt-6 btn-custom"
        depressed
        rounded
        block
        to="/ucc-login"
      >
        Login
      </v-btn>
    </v-navigation-drawer>
  </v-app-bar>
</template>

<script>
export default {
  name: "NewNavBar",
  data() {
    return {
      isMenuOpen: false,
      isScrolled: false,
      navLinks: [
        { name: "Home", href: "/home" },
        { name: "About Us", href: "/home#about" },
        { name: "Services", href: "/home#services" },
        { name: "Training", href: "/" },
        { name: "Join us", href: "/home#join" },
        // { name: "Testimonials", href: "#testimonials" },
        // { name: "Contact", href: "#contact" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },

    navigateTo(hash) {
      if (this.$route.path !== "/") {
        this.$router.push("/").then(() => {
          this.$nextTick(() => {
            setTimeout(() => {
              const el = document.querySelector(hash);
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }, 300);
          });
        });
      } else {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.container-custom {
  width: 100%;
}

.nav-link {
  text-transform: none !important;
  letter-spacing: normal !important;
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: var(--v-primary-base) !important;
}

.text-primary {
  color: var(--v-primary-base) !important;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
}

.btn-custom {
  padding: 12px 24px;
  font-weight: 500;
}
</style>
